import react from 'react'

const AccessDenied=()=>{

    return (<>
    </>)
}

export default AccessDenied;